// TODO: 3. Change controller name
// controller name: make sure manifest.json is same
// export const controllerName = "PTTOR_PortalCaseController";
// export const controllerName = "PTTOR_PortalBranchInfoController";
// export const controllerName = "PTTOR_NewsAndAnnouncementController";
// export const controllerName = "PTTOR_KnowledgeController";
// export const controllerName = "ForgotPasswordController";

// export const mainSite = "https://amazonconnect.pttor.com/FranchisePortal/";
// export const mainCafeSite = "https://pttororg1.my.salesforce-sites.com/CafeAmazonLogin";

export const mainCafeSite =
  "https://pttororg1--devpro1.sandbox.my.salesforce-sites.com/CafeAmazonLogin/";
export const mainSite =
  "https://pttororg1--devpro1.sandbox.my.site.com/FranchisePortal2/";

export const logOutUrl = mainSite + "LogoutPageVue";

// TODO: 1. Change main page
// Pages
// ==========Routine Page to Deploy========== //
export const mainPage = "Calendar";
export const controllerName = "PTTOR_PortalBranchInfoController";

// vue-router
export const basePath = "/FranchisePortal/" + mainPage;

// side menus
export const mainMenus = [
  {
    name: "หน้าหลัก",
    icon: "home",
    route: "Dashboard",
    deniedRoles: [],
    externalLink: null,
    children: [],
  },
  // franchiseMenus
  {
    name: "ข้อมูลร้าน",
    icon: "storefront",
    route: "",
    deniedRoles: ["บาริสต้า", "แม่บ้าน"],
    children: [
      {
        name: "ข้อมูลทั่วไป",
        icon: "shopping_cart",
        route: "BranchInfo",
      },
      {
        name: "ข้อมูลพนักงาน",
        icon: "shopping_cart",
        route: "EmployeeInfoList",
      },
      {
        name: "Delivery Partner",
        icon: "shopping_cart",
        route: "DeliveryPartnerList",
      },
    ],
  },
  // managerMenus
  {
    name: "Store Performance",
    icon: "insert_chart",
    route: "",
    deniedRoles: ["แม่บ้าน"],
    externalLink: null,
    children: [
      {
        name: "ยอดขาย",
        icon: "insert_chart",
        route: "Performance",
      },
      {
        name: "ยอดเงินโอนคืนจากกิจกรรมส่งเสริมการขาย",
        icon: "",
        route: "PerformanceRefund",
      },
    ],
  },
  {
    name: "การสั่งซื้อ (E-Order)",
    icon: "receipt_long",
    route: "EOrder",
    deniedRoles: [],
    externalLink: "https://eservice.pttor.com/PTTeOrdering/jsp/signOnNew.jsp",
    // "https://amazon-relocate-test.pttor.com/login.aspx?u=",
    children: [],
  },
  // caseMenu
  {
    name: "แจ้งเรื่อง/ติดตาม",
    icon: "edit_document",
    route: "",
    externalLink: null,
    deniedRoles: [],
    children: [
      {
        name: "แจ้ง/ติดตามการเคลม",
        icon: "leaderboard",
        route: "Claimlist",
      },
      {
        name: "แจ้ง/ติดตามการแจ้งซ่อม",
        icon: "leaderboard",
        route: "RepairList",
      },
      {
        name: "การติดตาม/ขอสื่อกิจกรรมส่งเสริมการขาย",
        icon: "leaderboard",
        route: "AdvertiseList",
      },
      {
        name: "แจ้ง/ติดตามการขอโปรโมชันรายสาขา",
        icon: "leaderboard",
        route: "PromotionList",
      },
      /*
      {
        name: "ติดตามสถานะการขนส่ง",
        icon: "leaderboard",
        // route: "",
      },
      */
    ],
  },
  {
    name: "สอบถาม/เสนอแนะ",
    icon: "plagiarism",
    route: "",
    deniedRoles: [],
    externalLink: null,
    children: [
      {
        name: "สอบถาม/ขอข้อมูล",
        icon: "leaderboard",
        route: "InquiryList",
      },
      {
        name: "ข้อเสนอแนะ",
        icon: "leaderboard",
        route: "ComplimentAndFeedbackList",
      },
      {
        name: "คำขออื่นๆ",
        icon: "leaderboard",
        route: "OthersList",
      },
    ],
  },
  {
    name: "ข่าวสารและกิจกรรมส่งเสริมการขาย",
    icon: "campaign",
    route: "",
    deniedRoles: [],
    externalLink: null,
    children: [
      {
        name: "ข่าวสารและโปรโมชัน",
        icon: "leaderboard",
        route: "News",
      },
      {
        name: "ปฎิทินทางการตลาด",
        icon: "leaderboard",
        route: "Calendar",
      },
    ],
  },
  {
    name: "หลักสูตรฝึกอบรม",
    icon: "school",
    route: "",
    deniedRoles: [],
    externalLink: null,
    children: [
      {
        name: "หลักสูตรฝึกอบรม (On-site)",
        icon: "leaderboard",
        route: "TrainingOffline",
      },
      {
        name: "หลักสูตรฝึกอบรม (Online)",
        externalLink: "https://elearning.cafe-amazon.com",
        icon: "leaderboard",
        route: "TrainingOnline",
      },
      {
        name: "ประวัติการลงทะเบียน",
        icon: "leaderboard",
        route: "TrainingHistory",
      },
    ],
  },
  {
    name: "บทความองค์ความรู้",
    icon: "leaderboard",
    route: "Article",
    externalLink: null,
    deniedRoles: [],
    children: [],
  },
  {
    name: "คำถามที่พบบ่อย (FAQ)",
    icon: "live_help",
    route: "Faq",
    externalLink: null,
    deniedRoles: [],
    children: [],
  },
  /*
  {
    name: "เอกสาร/แบบฟอร์ม",
    icon: "assignment",
    // route: "Forms",
    children: [],
  },
  */
  {
    name: "Contact Us",
    icon: "contacts",
    route: "",
    deniedRoles: [],
    externalLink: null,
    children: [
      {
        name: "เจ้าหน้าที่ OR",
        icon: "leaderboard",
        route: "BranchOfficerOR",
      },
      {
        name: "ข้อมูลการติดต่อ OR",
        icon: "leaderboard",
        route: "ContactOR",
      },
    ],
  },
];
export const franchiseMenus = [];

export const managerMenus = [
  // {
  //   name: "ข้อมูลผู้บริหาร",
  //   icon: "group",
  //   // route: "ManagerInfo",
  //   children: [],
  // },
];

export const caseMenu = [];

export const documentMenus = [
  // {
  //   name: "การนำส่งข้อมูลให้ OR",
  //   icon: "note_add",
  //   route: "ORDelivery",
  //   children: [],
  // },
];

export const breadCrumbs = [
  {
    mainPage: "EOrder",
    breadCrumbs: [
      {
        name: "การสั่งซื้อ (E-Order)",
        route: "EOrder",
      },
    ],
  },
  {
    mainPage: "ForgotPassword",
    breadCrumbs: [
      {
        name: "ForgotPassword",
        route: "ForgotPassword2",
      },
    ],
  },
  {
    mainPage: "AdvertiseList",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "การติดตาม/ขอกิจกรรมส่งเสริมการขาย",
        route: "AdvertiseList",
      },
    ],
  },
  {
    mainPage: "AdvertiseDetail",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "การติดตาม/ขอกิจกรรมส่งเสริมการขาย",
        route: "AdvertiseList",
      },
      {
        name: "รายละเอียด",
        route: "",
      },
    ],
  },
  {
    mainPage: "RepairList",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "แจ้ง/ติดตามการแจ้งซ่อม",
        route: "RepairList",
      },
    ],
  },
  {
    mainPage: "PromotionList",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "แจ้ง/ติดตามการขอโปรโมชันรายสาขา",
        route: "PromotionList",
      },
    ],
  },
  {
    mainPage: "PromotionForm",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "แจ้ง/ติดตามการขอโปรโมชันรายสาขา",
        route: "PromotionList",
      },
      {
        name: "รูปแบบเอกสาร",
        route: "",
      },
    ],
  },
  {
    mainPage: "PromotionDetail",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "แจ้ง/ติดตามการขอโปรโมชันรายสาขา",
        route: "PromotionList",
      },
      {
        name: "รายละเอียด",
        route: "",
      },
    ],
  },
  {
    mainPage: "InquiryList",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "สอบถาม/ขอข้อมูล",
        route: "InquiryList",
      },
    ],
  },
  {
    mainPage: "InquiryDetail",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "สอบถาม/ขอข้อมูล",
        route: "InquiryList",
      },
      {
        name: "รายละเอียด",
        route: "",
      },
    ],
  },
  {
    mainPage: "ComplimentAndFeedbackList",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "ข้อเสนอแนะ",
        route: "ComplimentAndFeedbackList",
      },
    ],
  },
  {
    mainPage: "ComplimentAndFeedbackDetail",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "ข้อเสนอแนะ",
        route: "ComplimentAndFeedbackList",
      },
      {
        name: "รายละเอียด",
        route: "",
      },
    ],
  },
  {
    mainPage: "OthersList",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "คำขออื่นๆ",
        route: "OthersList",
      },
    ],
  },
  {
    mainPage: "OthersDetail",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "คำขออื่นๆ",
        route: "OthersList",
      },
      {
        name: "รายละเอียด",
        route: "",
      },
    ],
  },
  {
    mainPage: "ClaimList",
    breadCrumbs: [
      {
        name: "แจ้งเรื่อง/ติดตาม",
        route: "",
      },
      {
        name: "แจ้ง/ติดตามการเคลม",
        route: "ClaimList",
      },
    ],
  },
  {
    mainPage: "FeedbackList",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "ข้อเสนอแนะ",
        route: "FeedbackList",
      },
    ],
  },
  {
    mainPage: "FeedbackForm",
    breadCrumbs: [
      {
        name: "สอบถาม/เสนอแนะ",
        route: "",
      },
      {
        name: "ข้อเสนอแนะ",
        route: "FeedbackList",
      },
      {
        name: "รูปแบบเอกสาร",
        route: "FeedbackForm",
      },
    ],
  },
  {
    mainPage: "BranchInfo",
    breadCrumbs: [
      {
        name: "ข้อมูลร้าน",
        route: "",
      },
      {
        name: "ข้อมูลทั่วไป",
        route: "BranchInfo",
      },
    ],
  },
  {
    mainPage: "EmployeeInfoList",
    breadCrumbs: [
      {
        name: "ข้อมูลร้าน",
        route: "",
      },
      {
        name: "ข้อมูลพนักงาน",
        route: "EmployeeInfoList",
      },
    ],
  },
  {
    mainPage: "EmployeeInfoDetail",
    breadCrumbs: [
      {
        name: "ข้อมูลร้าน",
        route: "",
      },
      {
        name: "ข้อมูลพนักงาน",
        route: "EmployeeInfoList",
      },
      {
        name: "รายละเอียด",
        route: "",
      },
    ],
  },
  {
    mainPage: "DeliveryPartnerList",
    breadCrumbs: [
      {
        name: "ข้อมูลร้าน",
        route: "",
      },
      {
        name: "Delivery Partner",
        route: "DeliveryPartnerList",
      },
    ],
  },
  {
    mainPage: "Article",
    breadCrumbs: [
      {
        name: "บทความองค์ความรู้",
        route: "Article",
      },
    ],
  },
  {
    mainPage: "ArticleDetail",
    breadCrumbs: [
      {
        name: "บทความองค์ความรู้",
        route: "Article",
      },
      {
        name: "",
        route: "",
      },
    ],
  },
  {
    mainPage: "Faq",
    breadCrumbs: [
      {
        name: "คำถามที่พบบ่อย (FAQs)",
        route: "Faq",
      },
    ],
  },
  {
    mainPage: "FaqDetail",
    breadCrumbs: [
      {
        name: "คำถามที่พบบ่อย (FAQs)",
        route: "Faq",
      },
      {
        name: "",
        route: "",
      },
    ],
  },
  {
    mainPage: "TrainingOffline",
    breadCrumbs: [
      {
        name: "หลักสูตรฝึกอบรม (On-site)",
        route: "TrainingOffline",
      },
    ],
  },
  {
    mainPage: "TrainingOnline",
    breadCrumbs: [
      {
        name: "หลักสูตรฝึกอบรม (Online)",
        route: "TrainingOnline",
      },
    ],
  },
  {
    mainPage: "TrainingDetail",
    breadCrumbs: [
      {
        name: "หลักสูตรฝึกอบรม",
        route: "TrainingOffline",
      },
      {
        name: "",
        route: "",
      },
    ],
  },
  {
    mainPage: "TrainingHistory",
    breadCrumbs: [
      {
        name: "ประวัติการลงทะเบียน",
        route: "",
      },
    ],
  },
  {
    mainPage: "News",
    breadCrumbs: [
      {
        name: "ข่าวสารและกิจกรรมส่งเสริมการขาย",
        route: "News",
      },
    ],
  },
  {
    mainPage: "NewsDetail",
    breadCrumbs: [
      {
        name: "ข่าวสารและกิจกรรมส่งเสริมการขาย",
        route: "News",
      },
      {
        name: "",
        route: "",
      },
    ],
  },
  {
    mainPage: "SearchCases",
    breadCrumbs: [
      {
        name: "ค้นหา",
        route: "SearchCases",
      },
    ],
  },
  // {
  // mainPage: "SearchNews",
  // breadCrumbs: [
  // {
  //   name: "ค้นหา",
  //   route: "SearchNews",
  // },
  // ],
  // },
  {
    mainPage: "SearchArticle",
    breadCrumbs: [
      {
        name: "ค้นหา",
        route: "SearchArticle",
      },
    ],
  },
  {
    mainPage: "SearchCourse",
    breadCrumbs: [
      {
        name: "ค้นหา",
        route: "SearchCourse",
      },
    ],
  },
  {
    mainPage: "Calendar",
    breadCrumbs: [
      {
        name: "ข่าวสารและกิจกรรมส่งเสริมการขาย",
        route: "News",
      },
      {
        name: "ปฎิทินทางการตลาด",
        route: "Calendar",
      },
    ],
  },
];
